import {
  IconArrowDown,
  IconArrowUp,
  IconCaretDown,
  IconCaretUp,
} from '@tabler/icons-react'
import { useEffect, useState } from 'react'

import { cn, getTrending } from '@/utils'

interface TrendLabelProps {
  oldValue?: number | string
  newValue: number | string
  isNormal?: boolean
  className?: string
  trendType: 'money' | 'percentage' | 'number' | 'hour'
  isMetricCard?: boolean
  verySmall?: boolean
  isBold?: boolean
}

export function TrendLabel({
  oldValue,
  newValue,
  isNormal = true,
  className,
  trendType,
  isMetricCard = false,
  verySmall = false,
  isBold = false,
}: TrendLabelProps) {
  const [trendDirection, setTrendDirection] = useState<string>()
  const [valueChange, setValueChange] = useState<string>()

  useEffect(() => {
    const [direction, change] = getTrending(newValue, trendType, oldValue)
    setTrendDirection(direction)
    setValueChange(change)
  }, [oldValue, newValue, trendType])

  const getTextColorClass = () => {
    if (trendDirection === 'unknown') return ''

    if (trendDirection === 'neutral') {
      return 'text-yellow-500'
    }

    if (trendDirection === 'down') {
      return isNormal ? 'text-red-500' : 'text-green-500'
    } else {
      return isNormal ? 'text-green-500' : 'text-red-500'
    }
  }

  return (
    <span
      className={cn(
        'flex items-center',
        isBold ? 'font-medium' : '',
        verySmall ? 'text-[11px]' : 'text-sm',
        getTextColorClass(),
        className
      )}
    >
      {trendDirection === 'unknown'
        ? '-'
        : trendDirection === 'neutral' && valueChange === '0'
          ? '0'
          : valueChange}
      {trendDirection === 'down' &&
        (isMetricCard ? (
          <IconArrowDown className="h-4 w-4" />
        ) : (
          <IconCaretDown className="h-4 w-4" />
        ))}
      {trendDirection === 'up' &&
        (isMetricCard ? (
          <IconArrowUp className="h-4 w-4" />
        ) : (
          <IconCaretUp className="h-4 w-4" />
        ))}
    </span>
  )
}
